import React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import { Link as NavLink } from 'react-router-dom';

function Link({ className, ...props }) {
  const classNameMerged = classnames(className);
  const Contaienr = props.to ? NavLink : 'a';
  return <Contaienr className={classNameMerged} {...props} />;
}

export default styled(Link)``;
